import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getPermissionRowIcon } from '../../utils/permissionMatrixUtils';
import useProfileSx from '../../hooks/useProfileSx';
import PermissionCheckboxCell from './PermissionCheckboxCell';

export default function PermissionMatrixRow({
  row,
  grants,
  columns,
  gridTemplateColumns,
  disabled = false,
  onFeatureChange,
  onObjectChange,
}) {
  const sx = useProfileSx();
  const Icon = getPermissionRowIcon(row);

  const getCellState = (columnKey) => {
    if (row.type === 'feature') {
      if (columnKey === 'can_view') {
        return {
          checked: Boolean(grants.features?.[row.codename]),
          inactive: false,
        };
      }
      return { checked: false, inactive: true };
    }

    const modelKey = (row.model || '').toLowerCase();
    return {
      checked: Boolean(grants.objects?.[modelKey]?.[columnKey]),
      inactive: false,
    };
  };

  const handleChange = (columnKey, granted) => {
    if (row.type === 'feature') {
      if (columnKey === 'can_view') {
        onFeatureChange?.(row.codename, granted);
      }
      return;
    }

    onObjectChange?.(row.model, columnKey, granted);
  };

  return (
    <Box sx={{ ...sx.permissionMatrixRow, gridTemplateColumns }}>
      <Box sx={sx.permissionMatrixRowLabel}>
        <Icon sx={sx.permissionMatrixRowIcon} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={sx.permissionMatrixRowTitle}>
            {row.label}
          </Typography>
          {row.groupLabel ? (
            <Typography variant="caption" sx={sx.permissionMatrixRowMeta}>
              {row.groupLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>

      {columns.map((column) => {
        const { checked, inactive } = getCellState(column.key);
        return (
          <PermissionCheckboxCell
            key={`${row.id}-${column.key}`}
            checked={checked}
            inactive={inactive}
            disabled={disabled || inactive}
            onChange={(granted) => handleChange(column.key, granted)}
          />
        );
      })}
    </Box>
  );
}
